import { doc, updateDoc } from "@firebase/firestore";
import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../../../api/firebase";
import { ProductsAutoComplete } from "../../../components/AutoComplete/Products";
import { RawItemsAutoComplete } from "../../../components/AutoComplete/RawItems";
//Create Bill Button
const collectionName = "product";

export const UpdateRecipeDialog = ({ open, onClose, items }) => {
  const products = useSelector((state) => state.products.products);

  const [quantity, setQuantity] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState();
  const [recipe, setRecipe] = useState([]);
  const [recipeSize, setRecipeSize] = useState(1);

  const updateRecipe = async (close) => {
    let product = products.find((prod) => prod.id === selectedProduct.id);
    let newProduct = { ...product, recipe, recipeSize };
    console.log(newProduct, recipe);
    try {
      await updateDoc(doc(db, collectionName, newProduct.id+""),{ recipe, recipeSize});

      toast.success("Successfully update  item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      // nbfProductInfo();
    } catch (error) {
      // console.log(error);
      toast.error("Failed to  update  item!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }

    if (close) {
      onClose();
    }
  };

  return (
    <Dialog open={open} size="lg" style={{ zIndex: 900 }}>
      <form onSubmit={(e) => e.preventDefault()}>
        <DialogContent>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "300px", sm: "360px", md: "550px" },
              gap: "1.5rem",
            }}
          >
            <Stack alignItems="center" spacing={1} direction="row">
              <ProductsAutoComplete
                value={selectedProduct}
                onChange={(e, newValue) => {
                  setSelectedProduct(newValue);
                  setRecipe(newValue.recipe || []);
                }}
              />
            </Stack>
            <Stack alignItems="center" spacing={1} direction="row">
                <TextField
                  sx={{ minWidth: "100%" }}
                  type="number"
                  label="Recipe Size"
                  value={recipeSize}
                  onChange={(e) => setRecipeSize(e.target.value)}
                />
            </Stack>
            <Stack alignItems="center" spacing={1} direction="row">
              <label style={{ minWidth: "30%" }}>
                <RawItemsAutoComplete
                  value={selectedItem}
                  onChange={(e, newValue) => {
                    console.log(newValue);
                    setSelectedItem(newValue);
                  }}
                />
                {/* <Autocomplete
                    disablePortal
                    label="Select Product"
                    id="combo-box-demo"
                    options={[]}
                    sx={{ minWidth: "100%" }}
                    value={selectedItem}
                    onChange={handleItemChange}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Item" />
                    )}
                  /> */}
              </label>
              <label style={{ minWidth: "20%" }}>
                <TextField
                  sx={{ minWidth: "100%" }}
                  type="number"
                  label="Enter Quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </label>
              <label style={{ minWidth: "10%" }}>
                <Button
                  variant="outlined"
                  sx={{
                    minWidth: "100%",
                    height: "55px",
                    bgcolor: "blue",
                    color: "white",
                  }}
                  onClick={() => {
                    if (!selectedItem || !quantity) return;
                    let index = recipe.findIndex(
                      (rec) => rec.name === selectedItem.name
                    );
                    if (index !== -1) {
                      recipe[index].quantity = quantity;

                      setRecipe([...recipe]);
                      setSelectedItem(null);
                      setQuantity(0);
                      return;
                    }
                    setRecipe([
                      ...recipe,
                      {
                        id: selectedItem.id,
                        name: selectedItem.name,
                        quantity: quantity,
                        unit: selectedItem.unit,
                        lastPrice: selectedItem.lastPrice,
                      },
                    ]);
                    setSelectedItem(null);
                    setQuantity(0);
                  }}
                >
                  Add
                </Button>
              </label>
            </Stack>

            <Table
              sx={{
                maxHeight: "10rem",
                overflowY: "auto",
                display: "block",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell width={"25%"} align="center">
                    Item
                  </TableCell>
                  <TableCell width={"25%"} align="center">
                    Quantity
                  </TableCell>
                  <TableCell width={"25%"} align="center">
                    Unit
                  </TableCell>
                  <TableCell width={"25%"} align="center">
                    Last Purchase
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {recipe.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{row.name}</TableCell>
                    <TableCell align="center">{row.quantity}</TableCell>
                    <TableCell align="center">{row.unit}</TableCell>
                    <TableCell align="center">{row.lastPrice}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Stack>
        </DialogContent>

        <Stack
          sx={{ p: "1.25rem" }}
          justifyContent="center"
          direction="row"
          spacing={1}
        >
          <Button id="cancel-button" onClick={onClose} variant="contained">
            Cancel
          </Button>
          <Button
            id="save-button"
            color="secondary"
            onClick={() => updateRecipe(false)}
            variant="contained"
          >
            Update
          </Button>
          <Button
            id="save-button"
            color="secondary"
            onClick={() => updateRecipe(true)}
            variant="contained"
          >
            Update & Close
          </Button>
        </Stack>
      </form>
    </Dialog>
  );
};
